import axios from '../axiosInstance'

const baseUrlApiOp = '/operation'
class CustomServices{

    getImporterBasedConsignment(importer_iec_no){
        return axios.get(baseUrlApiOp+'/getImporterBasedConsignment?importer_iec_no='+importer_iec_no)
    }
    getConsignmentJobEntryAssign(consignmentId){
        return axios.get(baseUrlApiOp+'/getConsignmentJobEntryAssign?consignmentId='+consignmentId)
    }
    getCustomActivity(consignmentId){
        return axios.get(baseUrlApiOp+'/getCustomActivity?consignmentId='+consignmentId)
    }
    getOperationStatus(){
        return axios.get(baseUrlApiOp+'/getOperationStatus')
    }
    insertCustomActivity(details){
        return axios.post(baseUrlApiOp+'/insertCustomActivity',details)
    }
    updateCustomActivity(details){
        return axios.put(baseUrlApiOp+'/updateCustomActivity',details)
    }
    deleteCustomActivity(customActivityId){
        return axios.delete(baseUrlApiOp+'/deleteCustomActivity?customActivityId='+customActivityId)
    }

}

export default new CustomServices()